export const header = 'Ενιαία Λίστα Χειρουργείων';
